module.exports = __webpack_public_path__ + "media/images/weather/64_day-f5cc0b0ac95c036c92eb9656b226e481.png";